export default {
  errMsg(errResp, msg) {
    if (errResp.status === 422) {
      msg = errResp.data.detail[0].msg
      return msg
    }
    msg = errResp.data.detail.user_msg ? errResp.data.detail.user_msg : msg
    return msg
  },
  checkEmail(rule, value, callback) {
    var myReg = /^[a-zA-Z0-9_-]+@+(sgidi\.com)$/
    if (myReg.test(value)) {
      return callback()
    } else {
      return callback(new Error('仅允许sgidi邮箱'))
    }
  },
  checkPwd(rule, value, callback) {
    var myReg = /(?=.*[0-9])(?=.*[a-zA-Z]).{8,30}/
    if (myReg.test(value)) {
      return callback()
    } else {
      return callback(new Error('密码中必须包含字母、数字，至少8个字符'))
    }
  },
  checkPwd2(rule, value, callback) {
    if (value !== this.registerForm.password1) {
      return callback(new Error('两次密码不一致'))
    } else {
      return callback()
    }
  },
  toAlgHelp(aid, router, newpage = false) {
    if (newpage) {
      const path = router.resolve({ path: '/help/aid_' + aid })
      window.open(path.href, '_blank')
    } else {
      router.push('/help/aid_' + aid)
    }
  }
}
